import { Tag, Tooltip } from '@eye-able/ui';
import { IconThumbUp } from '@tabler/icons-react';
import type { WcagLevel } from '@eye-able/types';

const COLORS = {
  A: '#a30000',
  AA: '#002060',
  AAA: '#15651b',
  'Best Practice': '#8510c7',
} satisfies Record<WcagLevel, string>;

const DISPLAY_NAME = {
  A: 'Level A',
  AA: 'Level AA',
  AAA: 'Level AAA',
  'Best Practice': 'Best Practice',
} as const satisfies Record<WcagLevel, string>;

interface LevelIconProps {
  level: WcagLevel;
  showName?: boolean;
}

const LevelIcon = function ({ level, showName }: LevelIconProps) {
  return (
    <div className='eye:flex eye:items-center'>
      <Tooltip side='top' content={DISPLAY_NAME[level]} asChild>
        <Tag
          className='eye:justify-center'
          aria-label={level}
          style={{
            background: COLORS[level],
          }}
        >
          {level === 'Best Practice' ? (
            <IconThumbUp color='white' size='17px' />
          ) : (
            level
          )}
        </Tag>
      </Tooltip>
      {showName && (
        <span aria-hidden className='eye:ml-3xs eye:truncate eye:font-bold'>
          {DISPLAY_NAME[level]}
        </span>
      )}
    </div>
  );
};

export default LevelIcon;
